module.exports = {"Deckenaufhängung":"Ceiling mount","Dreitälerblick Höhensteig":"Dreitälerblick High Trail","Esstischgruppe":"Dining table set","Granattor Höhensteig Millstatt":"Millstatt High Trail Garnetgate","Holzkohlegriller":"Charcoal grill","Kommode":"Commode","Spieltisch":"Games table","Vordach":"Porch","Wäscheaufhängung":"Drying rack","Weinkarussell":"Wine carousel","Weinregal Ausseneckvariante":"Wine rack outer corner variant","Wohnzimmertisch":"Coffee table"}


//////////////////
// WEBPACK FOOTER
// ./src/workpieces/translations.yml
// module id = 292
// module chunks = 11588923914802